import { LOGOUT_USER, CLOSE_USER_SESSIONS } from '../../../../constants/system/actions';

const logoutUser: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: LOGOUT_USER, payload, resolve, reject,
});

const closeUserSessions: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: CLOSE_USER_SESSIONS, payload, resolve, reject,
});

export {
  logoutUser,
  closeUserSessions,
};
